import { useCallback, useEffect, useState } from 'react'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell
} from '@table-library/react-table-library/table'
import { useTheme } from '@table-library/react-table-library/theme'
import { Button } from '@material-tailwind/react'
import PropTypes from 'prop-types'
import { FiArrowDown, FiArrowUp } from 'react-icons/fi'

const ExpandableTable = ({ data: resources, columns, gridTemplateColumns }) => {
  const [tableStatus, setTableStatus] = useState('collapsed')
  const rowQuantity = 2

  const isDecimal = (value) => {
    const num = parseFloat(value)
    return !isNaN(num) && num % 1 !== 0
  }

  const [data, setData] = useState({
    nodes: resources.slice(0, rowQuantity),
    meta: {}
  })

  useEffect(() => {
    setData({
      nodes: resources.slice(0, rowQuantity),
      meta: {}
    })
  }, [resources])

  const toggleRows = useCallback(() => {
    if (resources.length === data.nodes.length) {
      setTableStatus('collapsed')
      setData({
        nodes: resources.slice(0, rowQuantity)
      })

      return
    }

    setTableStatus('expanded')
    setData({
      nodes: resources
    })
  })

  const theme = useTheme({
    Table: `
--data-table-library_grid-template-columns: ${gridTemplateColumns || `repeat(${columns.length}, 1fr)`}
      `
  })

  return (
    <div className='flex flex-col justify-center items-center gap-4 h-full'>
      <Table data={data || []} theme={theme} layout={{ custom: true }}>
        {(tableList) => (
          <>
            <Header>
              <HeaderRow>
                {columns.map((column) => (
                  <HeaderCell key={column.key} resize>
                    {column.label}
                  </HeaderCell>
                ))}
              </HeaderRow>
            </Header>

            <Body>
              {tableList.map((item) => (
                <Row key={item.id} item={item}>
                  {columns.map((column) =>
                    isDecimal(item[column.key]) ? (
                      <Cell key={`${column.key}-${item.id}`}>
                        {item[column.key].toFixed(1)}
                      </Cell>
                    ) : (
                      <Cell key={`${column.key}-${item.id}`}>
                        {item[column.key]}
                      </Cell>
                    )
                  )}
                </Row>
              ))}
            </Body>
          </>
        )}
      </Table>

      {tableStatus === 'collapsed' ? (
        <Button
          variant='text'
          color='blue'
          className='w-fit flex items-center gap-2'
          onClick={() => toggleRows()}
        >
          Desplegar tabla
          <FiArrowDown className='h-5 w-5' />
        </Button>
      ) : (
        <Button
          variant='text'
          color='blue'
          className='w-fit flex items-center gap-2'
          onClick={() => toggleRows()}
        >
          Contraer tabla
          <FiArrowUp className='h-5 w-5' />
        </Button>
      )}
    </div>
  )
}

ExpandableTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
}

export { ExpandableTable }
